export default __webpack_public_path__ + "static/media/mal.7f03ba9a.png";